module.exports = __webpack_public_path__ + "static/media/Barmag FK6 700 Driven-.7667ee42.jpg";